// Global Instructions Rule Applied!

import { RoundState } from '../../interfaces/rounds.ts'
import { RoundEntryFields } from '../../data_models/round_entry.ts'

/**
 * Selector function to find a round by ID in rounds.data array
 * Returns the first match found, or undefined if not found
 *
 * Usage:
 * const round = useSelector((state) => selectRoundById(state, roundId))
 */
export const selectRoundById = (state: { rounds: RoundState }, roundId: string | number | null | undefined) => {
  if (!roundId || !state.rounds) return undefined

  const roundIdString = roundId.toString()

  const round = state.rounds.data.find((round) => round[RoundEntryFields.rounds__id]?.toString() === roundIdString)

  return round
}
